import { render, staticRenderFns } from "./DateAndTimeComponent.vue?vue&type=template&id=54aeea20&scoped=true&"
import script from "./DateAndTimeComponent.vue?vue&type=script&lang=js&"
export * from "./DateAndTimeComponent.vue?vue&type=script&lang=js&"
import style0 from "./DateAndTimeComponent.vue?vue&type=style&index=0&id=54aeea20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aeea20",
  null
  
)

export default component.exports